// generated by genversion
export var version = '3.4.4';
//# sourceMappingURL=version.js.map